const loaded = new Set()
let body = null

export default function(src) {
  // Exit if no script or script has already been loaded
  if (!src || loaded.has(src)) {
    return
  }

  // Cache body on first execution
  if (!body) {
    body = document.getElementsByTagName('body')[0]
  }

  // Track loaded scripts so they aren't ran twice
  loaded.add(src)

  const tag = document.createElement('script')
  tag.async = false
  tag.src = src

  // Appending the tag will download and execute the script
  body.appendChild(tag)
}
